import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'IndexPage',
    component: () => import('@/views/Index')
  },
  {
    path: '/logout',
    name: 'LogoutPage',
    component: () => import('@/views/Logout')
  },
  {
    path: '/test',
    name: 'TestPage',
    component: () => import('@/views/Test')
  },
  {
    path: '/:lang',
    name: 'IndexPageI18n',
    component: () => import('@/views/Index')
  },
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
